export default {
  namespaced: true,
  state: () => ({
    showUnitInfo: true,
    showPrice: true,
    units: [
      { UnitNumber: '002A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '002A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '003A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '004A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '005A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '006A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '007A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '008A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '009A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '010A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '011A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A01', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A02', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A03', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A04', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A05', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A06', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A07', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A08', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A09', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A10', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A11', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A12', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A13', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A14', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A15', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A16', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A17', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A18', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A19', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A20', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A21', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A22', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A23', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A24', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A25', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A26', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A27', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A28', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A29', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A30', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A31', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A32', _UnitStatus: '', disabled: false },
      { UnitNumber: '012A33', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA01', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA02', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA03', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA04', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA05', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA06', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA07', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA08', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA09', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA10', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA11', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA12', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA13', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA14', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA15', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA16', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA17', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA18', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA19', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA20', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA21', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA22', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA23', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA24', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA25', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA26', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA27', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA28', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA29', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA30', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA31', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA32', _UnitStatus: '', disabled: false },
      { UnitNumber: '12AA33', _UnitStatus: '', disabled: false },
    ],
  }),
  mutations: {
    set (state, { key, value }) {
      state[key] = value
    },
  },
}
